import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { ISiteMetadataRepository } from '../../domain/repositories/site-metadata.repository';

export namespace GetAllSiteMetadata {
  export const key = (input: Input) => [
    'records',
    'get-all-site-metadata',
    input.siteId,
  ];

  export type Params = { refetchInterval?: number };

  export type Input = ISiteMetadataRepository.GetAllInput;
  export type Output = ISiteMetadataRepository.GetAllOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.siteMetadata.getAll(input),
    });
  }
}
